import React from 'react';

const ChartCard = ({styleName, children}) => {
    return (
        <div className={`card border-0 ${styleName}`}>
            <div className="chart-header">
                {children[0]}
            </div>
            {children[1]}
        </div>
    )
};

export default ChartCard;




// WEBPACK FOOTER //
// ./components/dashboard/Common/ChartCard.js